__turbopack_context__.v({
  "ant-dropdown-menu": "index-module-scss-module__GUwc4G__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__GUwc4G__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__GUwc4G__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__GUwc4G__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__GUwc4G__back-top-wrap",
  "backHomeBtn": "index-module-scss-module__GUwc4G__backHomeBtn",
  "container": "index-module-scss-module__GUwc4G__container",
  "errorDesc": "index-module-scss-module__GUwc4G__errorDesc",
  "errorTitle": "index-module-scss-module__GUwc4G__errorTitle",
  "filterTableSelect": "index-module-scss-module__GUwc4G__filterTableSelect",
});
